<template>
  <section>
    <Title :title-name="pageTitle" />
    <div v-if="lang && lang['combine_passengers'] && pax && PaxsGroup.length" class="pax_contact_confirm">
      <div class="select_service pb20">
        <div v-if="isShowConfirm" class="container">
          <div class="mt-4">
            <ItemOfVouchers icon="contact-detail" color="#a7116f" :label="lang['pax_info_new'].SFS_LANG_ROW_1" border />
          </div>
          <div class="ws-textbox my-4">
            <div class="mb-4">{{ lang['combine_passengers'].SFS_LANG_ROW_15 }}</div>
            <div v-for="(p, index) in PaxsGroup" :key="p.passenger_id" class="contact_detail">
              <div class="d-flex">
                <div class="mb-2 w-100 title-pax flex-gap-3">
                  <span>{{ lang['combine_passengers'].SFS_LANG_ROW_6 }}</span>
                  <span>{{ index + 1 }}</span>
                </div>
              </div>
              <div class="d-flex input-passenger-info">
                <div v-if="airline['params'] && airline['params']['mobile_enable_GDPR'] == '1'" class="w-100">
                  <span class="input-label flex-fill d-flex justify-content-between">
                    <span> {{ lang['combine_passengers'].SFS_LANG_ROW_10 }}: </span>
                    <span class="text-this-is-me">
                      {{ lang['combine_passengers'].SFS_LANG_ROW_16 }}
                    </span>
                  </span>
                  <div class="d-flex align-items-center position-relative">
                    <input
                      v-model="p.firstNameConfirm"
                      :class="'pax-' + p.passenger_id"
                      class="input-name ml-0"
                      :placeholder="hideName(p.first_name)"
                    />
                    <div v-show="p.alertConfirmFirstNamePax && p.showFirstError" class="input-warning text-warning">
                      <i class="fas fa-exclamation-triangle"></i>
                    </div>
                    <div
                      v-show="p.alertConfirmFirstNamePax && p.showFirstError"
                      class="popover show bs-popover-top"
                      style="left: 20%; width: 100%; top: -200%"
                    >
                      <div class="arrow" style="left: 124px"></div>
                      <div class="popover-body">
                        {{ lang['combine_passengers'].SFS_LANG_ROW_17 }}
                      </div>
                    </div>
                  </div>
                  <span class="input-label flex-fill">{{ lang['combine_passengers'].SFS_LANG_ROW_11 }}:</span>
                  <div class="d-flex align-items-center position-relative mt-2">
                    <input
                      v-model="p.lastNameConfirm"
                      :class="'pax-' + p.passenger_id"
                      class="input-name ml-0"
                      :placeholder="hideName(p.last_name)"
                    />
                    <div v-show="p.alertConfirmLastNamePax && p.showFirstError" class="input-warning text-warning">
                      <i class="fas fa-exclamation-triangle"></i>
                    </div>
                    <div
                      v-show="p.alertConfirmLastNamePax && p.showFirstError"
                      class="popover show bs-popover-bottom"
                      style="left: 20%; width: 100%"
                    >
                      <div class="arrow" style="left: 124px"></div>
                      <div class="popover-body">
                        {{ lang['combine_passengers'].SFS_LANG_ROW_17 }}
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else class="w-100">
                  <div class="d-flex align-items-center position-relative">
                    <span class="input-label flex-fill d-flex justify-content-between">
                      <span class="flex-gap-3">
                        <span> {{ lang['combine_passengers'].SFS_LANG_ROW_10 }}: </span>
                        <span>{{ p.first_name }}</span>
                      </span>
                      <span class="text-this-is-me">
                        {{ lang['combine_passengers'].SFS_LANG_ROW_16 }}
                      </span>
                    </span>
                  </div>
                  <div class="d-flex align-items-center position-relative mt-2">
                    <span class="flex-gap-3">
                      <span class="input-label flex-fill">{{ lang['combine_passengers'].SFS_LANG_ROW_11 }}: </span>
                      <span>{{ p.last_name }}</span>
                    </span>
                  </div>
                </div>
                <div class="custom-control custom-checkbox ml-5">
                  <label class="ws-checkbox-container">
                    <input
                      :id="p.passenger_id"
                      v-model="curPaxID"
                      type="radio"
                      name="pax"
                      required
                      class="custom-control-input"
                      :value="p.passenger_id"
                    />
                    <span class="ws-checkbox-container__checkmark"></span>
                  </label>
                  <label class="custom-control-label custom-control-label__custom" :for="p.passenger_id"></label>
                </div>
              </div>
            </div>
            <div class="text-center py-3">
              <button class="ws-btn hd-normal-btn-background-color hd-normal-btn-color" @click="savePaxConfirm(curPaxID)">
                {{ lang['pax_info_new'].SFS_LANG_ROW_5 }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import '@/assets/scss/modules/PaxContactConfirm.scss'
import 'vue-tel-input/dist/vue-tel-input.css'
import Title from '@/components/Title/index'
import ItemOfVouchers from '@/components/ItemOfVouchers/index'

export default {
  name: 'PaxContactConfirm',
  components: {
    Title,
    ItemOfVouchers
  },
  props: {
    secret: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      curPaxInfo: null,
      curPaxID: null,
      invitation_key: 0,
      isShowConfirm: true,
      triggerTravelTogether: false,
      isSubmitForm: false,
      isWaitingReply: false,
      invitePaxs: [
        {
          pnr: '',
          first_name: '',
          last_name: '',
          phone_number: '',
          message: '',
          isValidPhone: true
        }
      ]
    }
  },
  computed: {
    routing() {
      // watcher airline and paxgroup to decide routing
      return this.airline && this.PaxsGroup
    },
    pageTitle() {
      const { lang } = this
      return lang && lang['pax_info_new'] && lang['pax_info_new'].SFS_LANG_ROW_7 ? lang['pax_info_new'].SFS_LANG_ROW_7 : 'Home'
    }
  },
  watch: {
    routing: function () {
      if (_.isEmpty(this.PaxsGroup) || _.isEmpty(this.airline)) {
        return
      }
      if (this.PaxsGroup.length < 2) {
        // Single passenger
        this.$router.push({ path: '/home', query: { secret: this.secret } })
        return
      }
    },
    PaxsGroup: function () {
      let aThis = this
      this.curPaxInfo = _.find(this.PaxsGroup, function (obj) {
        if (obj.passenger_id == aThis.pax.curPaxID) {
          return obj
        }
      })
      this.skipThisIsMe()
    },
    pax: {
      handler: function (oldPax, newPax) {
        if (!_.isUndefined(newPax) && !_.isEmpty(this.PaxsGroup)) {
          this.skipThisIsMe()
          this.triggerChangePax()
        }
      },
      deep: true
    }
  },
  created() {
    this.skipThisIsMe()
    this.initData()
    document.addEventListener('focusin', this.focusChanged)
  },
  beforeUnmount() {
    document.removeEventListener('focusin', this.focusChanged)
  },
  methods: {
    skipThisIsMe() {
      if (!_.isEmpty(this.pax) && !_.isEmpty(this.PaxsGroup) && _.size(this.PaxsGroup) == 1) {
        // Passenger is travelling alone then no need confirm "this is me"
        this.saveCurrentPax(this.pax.id)
      }
    },
    focusChanged(event) {
      if (!_.isEmpty(event.target.id)) {
        this.invitation_key = parseInt(event.target.id)
      }
    },
    triggerChangePax() {
      var self = this
      if (self.pax.curPaxID) {
        self.curPaxInfo = _.find(self.PaxsGroup, function (obj) {
          if (obj.passenger_id == self.pax.curPaxID) {
            return obj
          }
        })
      }
    },
    initData() {
      var self = this
      this.$store.dispatch('PaxContactConfirm/reFetchPaxGroup').then(function () {
        if (_.isEmpty(self.pax)) {
          return
        }

        let temp = _.find(self.PaxsGroup, { passenger_id: self.pax.id })
        if (temp) {
          _.extend(self.pax, temp)
        }
        let leaderParams = _.find(self.PaxsGroup, function (obj) {
          return obj.passenger_id == self.pax.paxLeadId
        })
        let listTravelTogether = self.pax.params.travel_together

        if (listTravelTogether && self.isConfirmYet) {
          // for leader
          if (!listTravelTogether.leader_id) {
            self.isWaitingReply = _.some(listTravelTogether, function (obj) {
              return obj.confirm_travel_together === '' || (obj.confirm_travel_together === 1 && obj.confirm_manage_book === '')
            })
            // for companion
          } else {
            // Check if leader still waiting for reply of others passenger
            let isWaiting = _.some(leaderParams.params.travel_together, function (obj) {
              return obj.confirm_travel_together === '' || (obj.confirm_travel_together === 1 && obj.confirm_manage_book === '')
            })
            if (isWaiting) {
              self.$router.push({ path: '/message', query: { secret: self.secret } })
            }
          }
        }
        self.triggerChangePax()
      })
      this.isShowConfirm = true
    },
    actionCheckPaxSuccess() {
      this.$store.commit('CONFIRM_UPDATE', true)
      this.$cookie.set('confirm' + this.pax.curPaxID, true)
      this.curPaxInfo.paxLeadId = this.curPaxInfo.paxLeadId === 0 ? this.curPaxInfo.passenger_id : this.curPaxInfo.paxLeadId
      this.$router.push({ path: '/home', query: { secret: this.secret } })
      return
    },
    savePaxConfirm(curPaxID) {
      let isCheck = false
      if (!curPaxID) {
        this.$swal('Please confirm who you are to continue')
        return isCheck
      }
      let leader = _.find(this.PaxsGroup, (pax) => {
        return pax.passenger_id == curPaxID
      })
      if (this.isInfant(leader)) {
        this.$swal('Leader can not be infant.')
        return isCheck
      }
      if (this.airline.params.mobile_enable_GDPR == 0 || this.confirmPax()) {
        this.saveCurrentPax(curPaxID)
        this.actionCheckPaxSuccess()
        isCheck = true
      }
      return isCheck
    },
    saveCurrentPax(curPaxID) {
      this.saveContact()
      this.$cookie.set('curPaxID' + this.pax.group_id, curPaxID)
      this.pax.curPaxID = curPaxID
      let currentPax = _.find(this.PaxsGroup, function (obj) {
        if (obj.passenger_id == curPaxID) {
          return obj
        }
      })
      this.curPaxInfo = currentPax
      this.$store.dispatch('PaxContactDetail/updatePhoneNumber', {
        pax_id: currentPax.passenger_id,
        phone_number: currentPax.phone_number,
        secret: this.secret
      })
    },
    checkNamePax(confirmName, paxName) {
      if (!_.isUndefined(confirmName)) {
        return _.isEqual(confirmName.trim().toUpperCase(), paxName.trim().toUpperCase())
      }
      return false
    },
    confirmPax() {
      let aThis = this
      let checkName = true
      _.each(this.PaxsGroup, function (obj) {
        aThis.$set(obj, 'showFirstError', false)
        if (obj.firstNameConfirm && obj.lastNameConfirm) {
          aThis.$set(obj, 'alertConfirmFirstNamePax', false)
          aThis.$set(obj, 'alertConfirmLastNamePax', false)
          if (!aThis.checkNamePax(obj.firstNameConfirm.trim(), obj.first_name)) {
            aThis.$set(obj, 'alertConfirmFirstNamePax', true)
            checkName = false
            aThis.$set(obj, 'showFirstError', true)
          }
          if (!aThis.checkNamePax(obj.lastNameConfirm.trim(), obj.last_name)) {
            aThis.$set(obj, 'alertConfirmLastNamePax', true)
            checkName = false
            aThis.$set(obj, 'showFirstError', true)
          }
        } else if (obj.firstNameConfirm) {
          aThis.$set(obj, 'alertConfirmFirstNamePax', false)
          if (!aThis.checkNamePax(obj.firstNameConfirm.trim(), obj.first_name)) {
            aThis.$set(obj, 'alertConfirmFirstNamePax', true)
          }
          aThis.$set(obj, 'alertConfirmLastNamePax', true)
          checkName = false
          aThis.$set(obj, 'showFirstError', true)
        } else if (obj.lastNameConfirm) {
          aThis.$set(obj, 'alertConfirmLastNamePax', false)
          if (!aThis.checkNamePax(obj.lastNameConfirm.trim(), obj.last_name)) {
            aThis.$set(obj, 'alertConfirmLastNamePax', true)
          }
          aThis.$set(obj, 'alertConfirmFirstNamePax', true)
          checkName = false
          aThis.$set(obj, 'showFirstError', true)
        } else {
          aThis.$set(obj, 'alertConfirmFirstNamePax', true)
          aThis.$set(obj, 'alertConfirmLastNamePax', true)
          checkName = false
          aThis.$set(obj, 'showFirstError', true)
        }
      })
      return checkName
    },
    saveContact() {
      var self = this
      let group_paxs = _.map(this.PaxsGroup, function (obj) {
        return {
          id: obj.passenger_id,
          phone: obj.phone_number
        }
      })

      this.$store.dispatch('PaxContactDetail/updatePassengersPhone', { group_passengers: group_paxs }).then((response) => {
        if (response.success) {
          if (self.PaxsGroup.length >= 2) {
            // 2 passengers
            // Check all of members have phone ?
            let isNotPhone = _.find(group_paxs, function (obj) {
              return !obj.phone
            })
            if (!isNotPhone) {
              self.pax.params.flow_status = 1
              self.pax.flow_status_enabled = true
            }
          } else {
            // Less than 3 passengers
            self.pax.params.flow_status = 1
          }
          return
        }
      })
      // Check state is updated or not
      if (!this.pax.paxLeadId) {
        this.pax.paxLeadId = this.curPaxID
      }
    },
    hideName(name) {
      let strHide = '*'
      if (name.length > 6) {
        return name.substring(0, 2) + strHide.repeat(name.length - 4) + name.substring(name.length - 2, name.length)
      }
      if (name.length >= 2) {
        return name.substring(0, 1) + strHide.repeat(name.length - 2) + name.substring(name.length - 1, name.length)
      }
      return name
    },
    onInput(formattedNumber, { number, isValid, country }) {
      let self = this
      if (number.input == '00' || number.input == '+00') {
        self.invitePaxs[self.invitation_key].phone_number = '+'
      } else if (number.international) {
        self.invitePaxs[self.invitation_key].phone_number = number.international
      }
      self.invitePaxs[self.invitation_key].isValidPhone = isValid
      if (!formattedNumber) {
        self.invitePaxs[self.invitation_key].isValidPhone = true
      }
    },
    isInfant(pax) {
      let invoicing_flag = pax.invoicing_flag
      if (pax && !_.isUndefined(pax.invoicing_flag) && !_.isNull(pax.invoicing_flag) && !_.isEmpty(pax.invoicing_flag)) {
        let position = invoicing_flag.search('INFT')
        if (position == -1) {
          position = invoicing_flag.search('INF')
        }
        return position != -1
      } else {
        let ssrs = pax.ssrs
        var v = ssrs.findLastIndex((o) => o.type == 'INFT')
        if (v != -1) {
          return v != -1
        }
        return ssrs.findLastIndex((o) => o.type == 'INF') != -1
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.error-message {
  color: red;
}
.title-size {
  font-size: 25px;
}
.vue-tel-input {
  border: 0;
}
.check-valid:invalid {
  border: red 1px solid;
}
.title-pax {
  font-size: 20px;
}

.input-passenger-info {
  ::v-deep .custom-control-label__custom::before {
    display: none !important;
  }

  .ws-checkbox-container {
    position: absolute;
    right: 0;
    top: 50px;
  }

  .text-this-is-me {
    position: relative;
    right: var(--text-this-is-me-right);
  }
}

.pax_contact_confirm .input-name {
  border-radius: 3px;
  background-color: #fafafa;
}
.flex-gap-3 {
  display: flex !important;
  gap: 3px;
}
</style>
